import { render, staticRenderFns } from "./createtlTask.vue?vue&type=template&id=52a75e60&scoped=true"
import script from "./createtlTask.vue?vue&type=script&lang=js"
export * from "./createtlTask.vue?vue&type=script&lang=js"
import style0 from "./createtlTask.vue?vue&type=style&index=0&id=52a75e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a75e60",
  null
  
)

export default component.exports